import { useState } from "react";
import "./Search.scss";
import { IconSearch } from "../Icons/Icons.mjs";

export default function Search({}) {
  const [value, setValue] = useState("");
  const searchFunction = (value) => {
    if (value) {
      let searchQuery = value
        .replace(/^[\s]{1,}/, "")
        .replace(/[\s]{1,}$/, "")
        .replace(/[\s]{1,}/g, "+");
      // window.history.pushState("1", "Title", `${process.env.REACT_APP_SEARCH_PREFIX}${searchQuery}`);
      // window.location.reload();
      window.location.href = `${process.env.REACT_APP_SEARCH_PREFIX}${searchQuery}`;
    }
  };
  return (
    <div className="search">
      <h2>Введите ваш запрос</h2>
      <div className="search__field">
        <input
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e?.keyCode === 13) {
              searchFunction(value);
            }
          }}
        ></input>
        <IconSearch
          classSvg={"cursor-pointer"}
          onClick={() => {
            searchFunction(value);
          }}
        />
      </div>
    </div>
  );
}
